import location from './location'
import globalFilter from './globalFilter'
export default {
	namespaced: true,
	modules: {
		location,
		globalFilter,
	},
}
